import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

import { BaseComponent } from 'anatoliapps-angular/components';

import { CartService } from '../../../core/services';
import { Cart, CartItem } from 'hakikat/models';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHandHoldingHeart, faXmark } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-cart',
  imports: [CommonModule, FontAwesomeModule, RouterLink],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent extends BaseComponent implements OnDestroy {

  //#region Font Awesome Icons
  iconCart = faHandHoldingHeart;
  iconXMark = faXmark;
  //#endregion

  //#region Cart Materials
  cart = signal<Cart | null>(null);

  readonly #cartService: CartService = inject(CartService);
  readonly #cartSubscription: Subscription = this.#cartService.cart$.subscribe(cart => this.cart.set(cart));
  //#endregion

  //#region Lifecycle Hooks
  ngOnDestroy(): void {
    this.#cartSubscription.unsubscribe();
  }
  //#endregion

  //#region Methods
  public onRemoveItem(item: CartItem): void {
    this.executeObservable(this.#cartService.removeFromCart(item.id)).subscribe();
  }
  //#endregion
}
